export const SystemBpMobileTabs = {
  Operations: {
    Settings: { id: "settings", name: "Settings" },
    Notifications: { id: "notifications", name: "Notifications" }
  }
};
